import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const IceSkating = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="ice-skating"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.865 42.096a3.565 3.565 0 003.56 3.56h5.47v6.414H7.234a1.465 1.465 0 000 2.93H42.3a12.441 12.441 0 0011.86-8.606 1.465 1.465 0 10-2.786-.907A9.518 9.518 0 0142.3 52.07h-1.563v-6.413h5.47a3.565 3.565 0 003.56-3.564v-.254H8.865v.257zm11.96 3.56h16.982v6.414H20.825v-6.413zM19.701 38.91h30.061l-.005-3.096-.001-.039c-.069-2.468-.983-4.784-2.576-6.52-1.64-1.788-3.815-2.772-6.126-2.772H31.008v-1.985H24.4a1.465 1.465 0 010-2.93h6.607v-2.766H24.4a1.465 1.465 0 010-2.93h6.607v-2.083H8.865v14.784c.162-.008.324-.012.488-.012 5.706 0 10.348 4.642 10.348 10.348z" />
      <path d="M9.353 31.49c-.164 0-.327.008-.488.019v7.4h7.907c0-4.09-3.328-7.418-7.42-7.418zM31.008 6.465c0-.81-.656-1.465-1.465-1.465H10.33c-.81 0-1.465.656-1.465 1.465v4.394h22.143V6.465z" />
    </svg>
  );
};
/* eslint-enable max-len */

IceSkating.defaultProps = {
  className: null,
};

IceSkating.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default IceSkating;
